import pdfobject from "pdfobject";
import { useState, useEffect } from "react";
import { Stack, Alert, Typography, CardMedia } from '@mui/material';
import { Card } from '@mui/material';


export default function CompatibilityCheck() {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const [pdfSupport, setPdfSupport] = useState()

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    useEffect(() => {
        if (pdfobject.supportsPDFs) {
            console.log("does support pdfObject")
            setPdfSupport(true)
            pdfobject.embed('https://crraoaimscs.res.in/assets/olympiad-brochure-2024.pdf', "#QuestionPaperCompatibilityCheck")
        } else {
            console.log("doesn't support pdfObject")
            setPdfSupport(false)
        }
    }, [])

    return (
        <Stack spacing={1} justifyContent={"center"} sx={{ p: 2 }}>
            <Alert severity={pdfSupport ? "success" : "error"} sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider", justifyContent: "center", alignItems: "center" }}>
                <Typography variant='h6' fontWeight={"bold"}>
                    {`This device is ${pdfSupport ? "" : "not"} compatible for the exam. Use compatible device to attend the exam`}
                </Typography>
            </Alert>
            <Card sx={{ border: 1, borderColor: "divider", boxShadow: 5, borderRadius: 3 }}>
                <CardMedia sx={{ height: dimensions.height - 200, width: "100%", minHeight: "500px", scrollbarWidth: "thin" }} component={"div"} id="QuestionPaperCompatibilityCheck" />
            </Card>
        </Stack>
    )
}